import Link from 'next/link';

import { getInternalLink } from '@/utils/url/utm';

import { SHARE_ON_TELEGRAM_CONTENT, SHARE_ON_TELEGRAM_LINK } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const Discussions: Component = ({
  discussions,
}) => {
  const formatDate = (timestamp: number) => {
    const date = new Date(timestamp * 1000);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };
  return (
    <div className={styles.containerRoot}>
      { discussions?.map(discussion => (
        <Link
          key={discussion.title}
          className={styles.containerItem}
          href={getInternalLink(discussion.link, 'discussions')}
          target="_blank">
          <div className={styles.textTitle}>
            {discussion.title}
            {' '}
          </div>
          <div className={styles.containerInfo}>
            <div className={styles.textRelies}>
              {discussion.replies}
              &nbsp;replies
            </div>
            <div className={styles.containerLastAction}>
              <span className={styles.textLastAction}>Last Action:&nbsp;</span>
              <span className={styles.textDate}>
                {formatDate(discussion.lastActionAt)}
              </span>
            </div>
          </div>
        </Link>
      )) }
      <div className={styles.containerLink}>
        <Link
          className={styles.linkShare}
          href={getInternalLink(SHARE_ON_TELEGRAM_LINK, 'discussions')}
          target="_blank">
          {SHARE_ON_TELEGRAM_CONTENT}
        </Link>
      </div>
    </div>
  );
};
